import { Box, Loader } from '@wix/design-system';
import React, { Suspense } from 'react';

type Props = {
  onEmojiAdd: (emoji: string) => void;
};

const EmojiSelector = React.lazy(
  () => import(/* webpackChunkName: "ricos_emojiInsertModal"  */ './emoji-selector')
);

const EmojiSelectorLazy = ({ onEmojiAdd }: Props) => (
  <Suspense
    fallback={
      <Box height={435} verticalAlign="middle" align="center">
        <Loader size="small" />
      </Box>
    }
  >
    <EmojiSelector onEmojiAdd={onEmojiAdd} />
  </Suspense>
);

export default EmojiSelectorLazy;
